import { faArrowLeft } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { cn } from "@scribenote/brian-design-system";
import { useNavigate } from "@tanstack/react-router";

type BackToClinicButtonProps = {
  dataTestId: string;
};

export const BackToClinicButton = ({ dataTestId }: BackToClinicButtonProps) => {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate({ to: "/" })}
      aria-label="Back to clinic"
      data-dd-action-name="Back to clinic"
      data-testid={dataTestId}
      className={cn(
        "flex h-9 w-9 items-center justify-center rounded-full text-ink-inverse",
        "transition-colors duration-150 ease-paper motion-reduce:transition-none",
        "hover:bg-paper/10",
        "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent-lite",
      )}
    >
      <FontAwesomeIcon icon={faArrowLeft} />
    </button>
  );
};
